import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, Button, Checkbox, FormControlLabel, FormLabel, MenuItem, TextField } from "@mui/material";

import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./departureCityMultiSelect.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CONFIGURATION } from "utilities/configuration";

class MultiSelectDeparture extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpened: false,
            departures: [],
            selectedValues: []
        };
    }

    componentDidMount() {
        this.getDepartures();
        const { deviationTypes, data, index } = this.props;
        const { deviationOptionIndex } = data || {};
        if (deviationTypes[deviationOptionIndex]?.departures?.length > 0) {
            const initialSelectedValues = [];
            deviationTypes[deviationOptionIndex]?.departures?.map((e, index) => {
                initialSelectedValues.push(e);
            });
            this.setState({
                selectedValues: initialSelectedValues
            });
            
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.departureCities?.data === null) {
            return ({
                menuOpened: false,
                departures: [],
                selectedValues: []
            });
        }

        if (nextProps.departureCities?.data !== prevState.departures) {
            const data = structuredClone(nextProps.departureCities?.data || []);
            if (prevState.departures && data) {
                if (data?.length > 0){
                  
                    // to detect if it is an array first
                    if(prevState.departures?.length > 0) {
                        prevState.departures?.map( country => {
                            country?.cities?.map(city => {
                                delete city.isChecked;
                            });
                        });
                    }
                    
                    data?.map( country => {
                        country?.cities?.map(city => {
                            delete city.isChecked;
                        });
                    });
                      
                    if((prevState.departures?.length > 0) && 
                    (JSON.stringify(prevState.departures) !== JSON.stringify(data))){
                        prevState.selectedValues = [];
                    }
                   
                    data?.map(country => {
                        country?.cities?.map(city => {
                            let matched = [];
                            if(prevState?.selectedValues?.length > 0){
                                matched = prevState?.selectedValues?.filter(e => e.code === city.code);
                            }
                            if(matched?.length !== 0){
                                city["isChecked"] = true;
                            } else {
                                city["isChecked"] = false;
                            }
                            
                            
                        });
                    });
                    
                }
                return ({ departures: data,
                    selectedValues: prevState?.selectedValues });
            }
            return ({ departures: data });
        }
        return null;
    }


    getDepartures() {
        let { departureCities } = this.props;
        let { departures } = this.state;
        if (departureCities?.data && departureCities?.data?.length > 0) {
            departures = departureCities?.data;
            this.setState({ departures });
        }
    }
    saveDestinations = () => {
        const { deviationTypes, handleStep2DeviationData, data } = this.props;
        const { deviationOptionIndex } = data || {};

        const { selectedValues } = this.state;

        let selectedCities = structuredClone(selectedValues);
        let deviationTypesClone = structuredClone(deviationTypes);

        deviationTypesClone[deviationOptionIndex].departures = selectedCities;

        handleStep2DeviationData(deviationTypesClone);
        this.setState({ menuOpened: false });
    };
    clearSelections = () => {
        let { departures, selectedValues } = this.state;
        departures.map(country => {
            country?.cities?.map(city => {
                city["isChecked"] = false;
            });
        });
        selectedValues = [];
        this.setState({ departures, selectedValues, menuOpened: false });

    };

    // handleData = (event, city) => {
    //     let { handleStep2Data, onDestinationChange } = this.props;

    //     let productType = commonUtilities.getProductType(this.props);
    //     console.log("producttype", productType);

    //     const { destination } = productType;

    //     destination.code = city ? city.code : "";
    //     destination.name = city ? city.name : "";
    //     destination.providerCode = city ? city.providerCode : "";

    //     handleStep2Data({ ...productType });
    //     onDestinationChange();
    // };
    updateSelectedValues(value, city, countryIndex, cityIndex) {
        let { selectedValues, departures } = this.state;
        if (value) {
            selectedValues.push({
                code: city?.code,
                name: city?.name,
                providerCode: city?.providerCode
            });
            departures[countryIndex].cities[cityIndex].isChecked = true;
        } else {
            let foundIndex = selectedValues?.findIndex(e => e.code === city.code);
            selectedValues?.splice(foundIndex, 1);
            departures[countryIndex].cities[cityIndex].isChecked = false;
        }
        this.setState({ selectedValues });
    }

    getRenderText(cities) {
        let text = [];
        if (cities?.length > 1) {
            cities.map(city => {
                text.push(`${"[" + city?.code + "] " + city?.name}`);
            });
            return text.join(", ");
        } else {
            return `${"[" + cities[0]?.code + "] " + cities[0]?.name}`;
        }
    }

    render() {
        let { citiesMasterData, errors } = this.props;
        let { menuOpened, selectedValues, departures } = this.state;
        let productType = commonUtilities.getProductType(this.props);
        if (!productType) return;

        let { destination } = productType;
        let cities = citiesMasterData?.data?.cities
            ? citiesMasterData?.data?.cities || []
            : [];
        let selectPlaceHolder = this.props.localize("qma-select-label");

        const hasError = errors?.deviationError?.departure?.trim()?.length > 0 || false;

        return (
            <div className="row departure-city-container">
                <div className={"row form-control-wrapper" + (departures?.length === 0 ? " disabled" : "")}>
                    <FormLabel>
                        Departure City
                    </FormLabel>
                    <div className="selector-wrapper">
                        <input type="text"
                            className={ (this.state.menuOpened ? "departure-city-input menu-open" : "departure-city-input") + (hasError ? " invalid" : "")}
                            onClick={() => this.setState({ menuOpened: true })}
                            value={selectedValues?.length > 0 ? this.getRenderText(selectedValues) : selectPlaceHolder}
                            readOnly={true}
                            disabled={departures?.length === 0}
                        />
                        <span className={(this.state.menuOpened ? "select-caret invert" : "select-caret") + (departures?.length === 0 ? " disabled" : "")}> {CONFIGURATION.APPLY_FIELD_ADORNMENT ? <ExpandMoreIcon /> : <ArrowDropDownIcon /> } </span>
                    </div>
                </div>
                {menuOpened ?
                    <div className="departure-city-wrapper ">
                        <div className="departure-city-popup">
                            <div className="select-info">Select up to 3 departure cities</div>
                            <div className="list-container">
                                <div className="countries-container">
                                    <ul>
                                        {departures?.map((country, countryIndex) => (
                                            <li className="countries" keys={countryIndex}>
                                                <div className="country-label">{country?.countryName}</div>
                                                <div className="cities-container">
                                                    {country?.cities?.map((city, cityIndex) => (
                                                        <div className="cities">
                                                            <FormControlLabel
                                                                id={`${"chekbox-" + countryIndex + "-" + cityIndex}`}
                                                                control={
                                                                    <Checkbox 
                                                                        onChange={(e) => this.updateSelectedValues(e?.target?.checked, city, countryIndex, cityIndex)}
                                                                        checked={city.isChecked}
                                                                        disabled={selectedValues?.length > 2 && !city.isChecked}
                                                                    />}
                                                                label={city?.name}
                                                            />
                                                        </div>
                                                    ))}

                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="bottom-section">
                            <Button variant="outlined" size="small" className="pull-right" onClick={() => this.saveDestinations()}> Done</Button>
                            <Button variant="text" size="small" className="pull-right" onClick={() => this.clearSelections()}> Clear all</Button>
                        </div>

                    </div> : null

                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    departureCities: state.departures
});

export default connect(mapStateToProps)(withLocalizer(MultiSelectDeparture));